import React, { useEffect, useState, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import * as colors from "../../assets/css/Colors";
import { Link } from "react-router-dom";

import { FaArrowRightLong } from "react-icons/fa6";
import Img_1 from '../../images/school-collage.jpg';

// 
import Location from '../../modal/Location';
import { FaStar } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { FaFacebookSquare } from "react-icons/fa";

const SchoolCollege = () => {
    const [pincode, setPincode] = useState('');
    const [error, setError] = useState(null);
  
    const handleLocationUpdate = async (updatedLocation) => {
      try {
        const pincodeMatch = updatedLocation.match(/\b\d{6}\b/);
        const newPincode = pincodeMatch ? pincodeMatch[0] : '';
        setPincode(newPincode);
      } catch (error) {
        setError(error.message);
      }
    };

  // Start color change auto function
  const [colorScheme, setColorScheme] = useState(
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      setColorScheme(e.matches ? 'dark' : 'light');
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);
  // End color change auto function
  //  gradient color Start
  const styles = {
    background: colorScheme === 'dark'
      ? `linear-gradient(to right, ${colors.theme_black_color}, ${colors.theme_black_color}, ${colors.theme_white_color})`
      : `linear-gradient(to right, ${colors.theme_white_color}, ${colors.theme_white_color}, ${colors.theme_black_color})`,
  };
  const stylereview = {
    backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color,
    border: `1px solid ${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}`,
  }
  const boxstyleqrcode = {
    border: `2px solid ${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}`,
    borderRadius: '8px',
  };
  // gradient color End
  return (
    <>
  <section className='section'>
<div className='loctionbuttonhide'>
<Location onLocationUpdate={handleLocationUpdate}/>
</div>
<Container>
  <Row>
    <Col sm={12} style={{paddingTop: '50px'}}>
      <div className="ad-dash-s1">
        <div className="cd-cen-intr-inn" style={styles}>
          <h2><b>Hi Welcome To Do Digitals Education</b></h2>
          <p>Discover detailed information about Government and Private Schools & Colleges, including local and national data. Learn about school and college counts, teacher and student statistics, performance metrics, and facilities. Get insights into attendance, behavior, events, and more. Students can contribute by posting research papers, reviews, and feedback. Your comprehensive resource for all educational insights.</p>
        </div>
      </div>
    </Col>
    <Col sm={12}>
      <div className="home-tit">
        <h2><span> Detailed Info on Local Area</span> <form onSubmit={(e) => e.preventDefault()}>
          <input
            type="text" className='popuple-data-count-pincode' style={boxstyleqrcode}
            value={pincode}
            onChange={(e) => setPincode(e.target.value)}
            placeholder="Pincode"
          />
        </form> &nbsp; <span>Schools & Colleges</span> </h2>
        <p>Which local area's information would you like to know? Enter the pincode of that local area where a pincode (6 digits) is already available.</p>
        <p>Find key details about Government and Private Schools & Colleges in your local area.</p>
      </div>
      <div className="ad-dash-s4">
        <Row>
          <Col sm={4}>
          <div className="grid-item-holder gallery-items fl-wrap">

<div className="gallery-item restaurant events">

    <div className="listing-item">
        <article className="geodir-category-listing fl-wrap">
            <div className="geodir-category-img">
                <a href="listing-single.html" className="geodir-category-img-wrap fl-wrap">
                <img src={Img_1} />
                </a>
                <div className="listing-avatar">
                    <a href="author-single.html">
                    <img src={Img_1} />
                    </a>
                </div>
                <div className="geodir-category-opt">
                    <div className="listing-rating-count-wrap">
                        <div className="review-score" style={stylereview}>4.8</div>
                        <div className="listing-rating card-popup-rainingvis">
                          <FaStar />
                          <FaStar />
                          <FaStar />
                          <FaStar />
                          <FaStar />
                        </div>
                        <br></br>
                        <div className="reviews-count">12 reviews</div>
                    </div>
                </div>
            </div>
            <div className="geodir-category-content fl-wrap title-sin_item">
                <div className="geodir-category-content-title fl-wrap">
                    <div className="geodir-category-content-title-item">
                        <h3 className="title-sin_map">
                            <a href="listing-single.html">Government Schools</a>
                        </h3>
                        <div className="geodir-category-location fl-wrap">
                               <FaLocationDot />
                                Jaipur, Rajasthan 302021, India
                        </div>
                    </div>
                </div>
                <div className="geodir-category-text fl-wrap">
                    <p className="small-text">Find key details about Government and Private Schools & Colleges in your local area.</p>
                </div>
                <div className="geodir-category-text fl-wrap border-top">
                    <div className="facilities-list fl-wrap">
                        <div className="facilities-list-title">Social Media : </div>
                        <ul className="no-list-style">
                            <li className="tolt" data-microtip-position="top" data-tooltip="Free WiFi">
                                <FaFacebookSquare />
                            </li>
                            <li className="tolt" data-microtip-position="top" data-tooltip="Parking">
                            <FaFacebookSquare />
                            </li>
                            <li className="tolt" data-microtip-position="top" data-tooltip="Non-smoking Rooms">
                            <FaFacebookSquare />
                            </li>
                            <li className="tolt" data-microtip-position="top" data-tooltip="Pets Friendly">
                            <FaFacebookSquare />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </article>
    </div>

</div>

</div>
          </Col>
          <Col sm={4}>
          <div className="grid-item-holder gallery-items fl-wrap">

<div className="gallery-item restaurant events">

    <div className="listing-item">
        <article className="geodir-category-listing fl-wrap">
            <div className="geodir-category-img">
                <a href="listing-single.html" className="geodir-category-img-wrap fl-wrap">
                <img src={Img_1} />
                </a>
                <div className="listing-avatar">
                    <a href="author-single.html">
                    <img src={Img_1} />
                    </a>
                </div>
                <div className="geodir-category-opt">
                    <div className="listing-rating-count-wrap">
                        <div className="review-score" style={stylereview}>4.8</div>
                        <div className="listing-rating card-popup-rainingvis">
                          <FaStar />
                          <FaStar />
                          <FaStar />
                          <FaStar />
                          <FaStar />
                        </div>
                        <br></br>
                        <div className="reviews-count">12 reviews</div>
                    </div>
                </div>
            </div>
            <div className="geodir-category-content fl-wrap title-sin_item">
                <div className="geodir-category-content-title fl-wrap">
                    <div className="geodir-category-content-title-item">
                        <h3 className="title-sin_map">
                            <a href="listing-single.html">Private Schools</a>
                        </h3>
                        <div className="geodir-category-location fl-wrap">
                               <FaLocationDot />
                                Jaipur, Rajasthan 302021, India
                        </div>
                    </div>
                </div>
                <div className="geodir-category-text fl-wrap">
                    <p className="small-text">Find key details about Government and Private Schools & Colleges in your local area.</p>
                </div>
                <div className="geodir-category-text fl-wrap border-top">
                    <div className="facilities-list fl-wrap">
                        <div className="facilities-list-title">Social Media : </div>
                        <ul className="no-list-style">
                            <li className="tolt" data-microtip-position="top" data-tooltip="Free WiFi">
                                <FaFacebookSquare />
                            </li>
                            <li className="tolt" data-microtip-position="top" data-tooltip="Parking">
                            <FaFacebookSquare />
                            </li>
                            <li className="tolt" data-microtip-position="top" data-tooltip="Non-smoking Rooms">
                            <FaFacebookSquare />
                            </li>
                            <li className="tolt" data-microtip-position="top" data-tooltip="Pets Friendly">
                            <FaFacebookSquare />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </article>
    </div>

</div>

</div>
          </Col>
          <Col sm={4}>
          <div className="grid-item-holder gallery-items fl-wrap">

<div className="gallery-item restaurant events">

    <div className="listing-item">
        <article className="geodir-category-listing fl-wrap">
            <div className="geodir-category-img">
                <a href="listing-single.html" className="geodir-category-img-wrap fl-wrap">
                <img src={Img_1} />
                </a>
                <div className="listing-avatar">
                    <a href="author-single.html">
                    <img src={Img_1} />
                    </a>
                </div>
                <div className="geodir-category-opt">
                    <div className="listing-rating-count-wrap">
                        <div className="review-score" style={stylereview}>4.8</div>
                        <div className="listing-rating card-popup-rainingvis">
                          <FaStar />
                          <FaStar />
                          <FaStar />
                          <FaStar />
                          <FaStar />
                        </div>
                        <br></br>
                        <div className="reviews-count">12 reviews</div>
                    </div>
                </div>
            </div>
            <div className="geodir-category-content fl-wrap title-sin_item">
                <div className="geodir-category-content-title fl-wrap">
                    <div className="geodir-category-content-title-item">
                        <h3 className="title-sin_map">
                            <a href="listing-single.html">Government Colleges</a>
                        </h3>
                        <div className="geodir-category-location fl-wrap">
                               <FaLocationDot />
                                Jaipur, Rajasthan 302021, India
                        </div>
                    </div>
                </div>
                <div className="geodir-category-text fl-wrap">
                    <p className="small-text">Find key details about Government and Private Schools & Colleges in your local area.</p>
                </div>
                <div className="geodir-category-text fl-wrap border-top">
                    <div className="facilities-list fl-wrap">
                        <div className="facilities-list-title">Social Media : </div>
                        <ul className="no-list-style">
                            <li className="tolt" data-microtip-position="top" data-tooltip="Free WiFi">
                                <FaFacebookSquare />
                            </li>
                            <li className="tolt" data-microtip-position="top" data-tooltip="Parking">
                            <FaFacebookSquare />
                            </li>
                            <li className="tolt" data-microtip-position="top" data-tooltip="Non-smoking Rooms">
                            <FaFacebookSquare />
                            </li>
                            <li className="tolt" data-microtip-position="top" data-tooltip="Pets Friendly">
                            <FaFacebookSquare />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </article>
    </div>

</div>

</div>
          </Col>
        </Row>
    
      </div>
      <div className='view-more-button'>
        <Link to="/Card">
          <span className="btn-ser-need-ani Add-Any-Equation" style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>More Information of Your Local Area</span>
        </Link>
      </div>
    </Col>
  </Row>
</Container>
</section>
    </>
  )
}

export default SchoolCollege